export default __webpack_public_path__ + "static/media/c14.d5dd1e51.png";